(function () {
  'use strict';

  function initSupportPage(root) {
    if (!root || root.dataset.supportReady === 'true') return;
    root.dataset.supportReady = 'true';

    var topicButtons = Array.prototype.slice.call(root.querySelectorAll('[data-support-topic]'));
    var topicSelect = root.querySelector('[data-support-topic-select]');
    var message = root.querySelector('[data-support-message]');
    var count = root.querySelector('[data-support-character-count]');
    var chatTrigger = root.querySelector('[data-support-chat-trigger]');
    var formSuccess = root.querySelector('[data-support-form-success]');

    function selectTopic(value, moveFocus) {
      topicButtons.forEach(function (button) {
        var selected = button.dataset.supportTopic === value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) button.focus();
      });
      if (topicSelect && topicSelect.value !== value) {
        topicSelect.value = value;
        topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    topicButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        selectTopic(button.dataset.supportTopic, false);
      });
      button.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % topicButtons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + topicButtons.length) % topicButtons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = topicButtons.length - 1;
        if (typeof nextIndex === 'number') {
          event.preventDefault();
          selectTopic(topicButtons[nextIndex].dataset.supportTopic, true);
        }
      });
    });

    if (topicSelect) {
      topicSelect.addEventListener('change', function () {
        selectTopic(topicSelect.value, false);
      });
      selectTopic(topicSelect.value, false);
    }

    function updateCount() {
      if (count && message) count.textContent = String(message.value.length);
    }
    if (message) {
      message.addEventListener('input', updateCount);
      updateCount();
    }

    function openShopifyChat(attempt) {
      var host = document.querySelector('shopify-chat');
      var button = host && host.shadowRoot && host.shadowRoot.querySelector('button.activator');
      if (button) {
        button.click();
        return;
      }
      if (attempt < 16) window.setTimeout(function () { openShopifyChat(attempt + 1); }, 250);
    }
    if (chatTrigger) chatTrigger.addEventListener('click', function () { openShopifyChat(0); });

    if (formSuccess) {
      formSuccess.focus({ preventScroll: true });
      formSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function boot() {
    var root = document.querySelector('[data-support-page]');
    if (root) initSupportPage(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
